import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Visible FAQ + matching schema.org FAQPage JSON-LD (separate script id so it never
// clashes with the page's primary Seo JSON-LD). Helps search engines and AI assistants
// quote accurate answers about how FlightDeals.in works.
export function FaqSection({ faqs = [], title = 'Frequently asked questions', scriptId = 'faq-jsonld' }) {
  const [open, setOpen] = useState(0);

  useEffect(() => {
    if (!faqs.length) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = scriptId;
    el.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question', name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    document.head.appendChild(el);
    return () => { const e = document.getElementById(scriptId); if (e) e.remove(); };
  }, [faqs, scriptId]);

  if (!faqs.length) return null;
  return (
    <section className="mt-12" data-testid="faq-section">
      <h2 className="font-display text-xl font-semibold mb-4">{title}</h2>
      <div className="space-y-2">
        {faqs.map((f, i) => (
          <div key={i} className="rounded-xl border border-border bg-card overflow-hidden" data-testid={`faq-item-${i}`}>
            <button onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left font-medium hover:bg-secondary/40"
              data-testid={`faq-q-${i}`}>
              <span>{f.q}</span>
              <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
            </button>
            {open === i && <p className="px-4 pb-4 text-sm text-muted-foreground leading-relaxed" data-testid={`faq-a-${i}`}>{f.a}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
